import React, { useState, useEffect } from "react";
import ContentSvg from "../assets/images/svg/content-svg.svg";
import ContentImg from "../assets/images/content-img.png";
import YoutubeVideoImg from "../assets/images/youtube-video-img.png";
import YoutubeSvg from "../assets/images/svg/youtube-svg.svg";
import VimeoVideoImg from "../assets/images/vimeo-video-img.png";
import VimeoSvg from "../assets/images/svg/vimeo-svg.svg";
import SoundCloudImg from "../assets/images/sound-cloud-img.png";
import SoundCloudSvg from "../assets/images/svg/sound-cloud.svg";
import GalleryImg from "../assets/images/gallery-img.png";
import GallerySvg from "../assets/images/svg/gallery-svg.svg";
import ContentImg2 from "../assets/images/content-img2.png";
import YouTubeModal from "./YouTubeVideo";
import VimeoModal from "./VimeoModal";
import SoundCloudModal from "./SoundCloudVideo";
import $ from "jquery";
import Galleryimg1 from "../assets/images/gallery/gallery-img1.jpg";
import Galleryimg2 from "../assets/images/gallery/gallery-img2.jpg";
import Galleryimg3 from "../assets/images/gallery/gallery-img3.jpg";
import Galleryimg4 from "../assets/images/gallery/gallery-img4.jpg";
import Galleryimg5 from "../assets/images/gallery/gallery-img5.jpg";
import Galleryimg6 from "../assets/images/gallery/gallery-img6.jpg";
import Galleryimg7 from "../assets/images/gallery/gallery-img7.jpg";
import Galleryimg8 from "../assets/images/gallery/gallery-img8.jpg";
import Fancybox from "./FancyBox";
import Popup from "./PopUp";
import { Link } from "react-router-dom";

const Portfolio = () => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const handlePopupOpen = (e) => {
    e.preventDefault();
    setIsPopupVisible(true);
  };

  const handlePopupClose = (e) => {
    e.preventDefault();
    setIsPopupVisible(false);
  };

  // Vimeo Modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // Youtube Modal
  const [isModalOpenYoutube, setisModalOpenYoutube] = useState(false);

  const handleOpenModalYoutube = () => {
    setisModalOpenYoutube(true);
  };

  const handleCloseModalYoutube = () => {
    setisModalOpenYoutube(false);
  };

  // Soundcloud Modal
  const [isModalOpenSound, setIsModalOpenSound] = useState(false);

  const handleOpenModalSound = () => {
    setIsModalOpenSound(true);
  };

  const handleCloseModalSound = () => {
    setIsModalOpenSound(false);
  };

  useEffect(() => {
    // Function to initialize fancybox for the gallery

    // Event listener to toggle 'full' class on image click
    const handleImageClick = (event) => {
      event.target.classList.toggle("full");
    };

    // Attach click event to gallery images
    const galleryLinks = document.querySelectorAll(".gallery-link img");
    galleryLinks.forEach((link) => {
      link.addEventListener("click", handleImageClick);
    });

    // Cleanup function to remove event listeners when component unmounts
    return () => {
      galleryLinks.forEach((link) => {
        link.removeEventListener("click", handleImageClick);
      });
    };
  }, []);
  return (
    <>
      {/* <!-- ====================================== Section Portfolio ===================================== --> */}
      <section className="portfolio-section" id="portfolio">
        <div className="heading-container">
          <h2 className="section-heading-text coding-skill-text fade_up">
            Portfolio.
          </h2>
          <div className="line"></div>
        </div>
        <div className="portfolios-group-main">
          {/* Portfolio Item One  */}
          <div>
            <div
              className="image-container popup-btn zoom_in"
              onClick={() =>
                window.open("https://www.behance.net/gallery/232309971/Jewellery-Social-Media-Post-Design", "_blank")
              }
              style={{ cursor: "pointer" }}
            >
              <img src={Galleryimg1} alt="Jewellery Social Media Post Design" loading="lazy" />
              <div className="overlay">
                <img src={ContentSvg} alt="Portfolio icon" className="vimeo-icon" />
                <p className="overlay-text">Jewellery Presentation</p>
              </div>
            </div>

            <p className="Corporate zoom_in">Jewellery Presentation</p>
            <p className="Corporate-sub zoom_in">Social Media Post</p>
          </div>
          {/* Portfolio Item Two  */}
          <div>
            <div
              className="image-container popup-btn zoom_in"
              onClick={() =>
                window.open("https://www.behance.net/gallery/206327219/Organic-Hair-Oil-Social-Media-Post-", "_blank")
              }
              style={{ cursor: "pointer" }}
            >
              <img src={Galleryimg2} alt="Organic Hair Oil Social Media Post" loading="lazy" />
              <div className="overlay">
                <img src={ContentSvg} alt="Portfolio icon" className="vimeo-icon" />
                <p className="overlay-text">Organic Hair Oil</p>
              </div>
            </div>

            <p className="Corporate zoom_in">Organic Hair Oil</p>
            <p className="Corporate-sub zoom_in">Social Media Post</p>
          </div>
          {/* Portfolio Item Three  */}
          <div>
            <div
              className="image-container popup-btn zoom_in"
              onClick={() =>
                window.open("https://www.behance.net/gallery/205353379/Mens-T-shirt-Social-Media-Post", "_blank")
              }
              style={{ cursor: "pointer" }}
            >
              <img src={Galleryimg3} alt="Mens T-shirt Manipulation" loading="lazy" />
              <div className="overlay">
                <img src={ContentSvg} alt="Portfolio icon" className="vimeo-icon" />
                <p className="overlay-text">Mens T-shirt Manipulation </p>
              </div>
            </div>

            <p className="Corporate zoom_in">Mens T-shirt Manipulation</p>
            <p className="Corporate-sub zoom_in">Social Media Post</p>
          </div>

          
        </div>

        <div className="portfolios-group-main">
              {/* Portfolio Item Four  */}
          <div>
            <div
              className="image-container popup-btn zoom_in"
              onClick={() =>
                window.open("https://www.behance.net/gallery/233808503/Agriculture-Social-Media-Post-Design", "_blank")
              }
              style={{ cursor: "pointer" }}
            >
              <img src={Galleryimg4} alt="Agriculture Social Media Banner Design" loading="lazy" />
              <div className="overlay">
                <img src={ContentSvg} alt="Portfolio icon" className="vimeo-icon" />
                <p className="overlay-text">Agriculture Social</p>
              </div>
            </div>

            <p className="Corporate zoom_in">Agriculture Social</p>
            <p className="Corporate-sub zoom_in">Banner Design</p>
          </div>
          {/* Portfolio Item Five  */}
          <div>
            <div
              className="image-container popup-btn zoom_in"
              onClick={() =>
                window.open("https://www.behance.net/gallery/135731753/Uniguide-UIUX-Case-Study-on-Study-Abroad-Info-App", "_blank")
              }
              style={{ cursor: "pointer" }}
            >
              <img src={Galleryimg5} alt="Uniguide App UI/UX Case Study" loading="lazy" />
              <div className="overlay">
                <img src={ContentSvg} alt="Portfolio icon" className="vimeo-icon" />
                <p className="overlay-text">App UI/UX</p>
              </div>
            </div>

            <p className="Corporate zoom_in">App UI/UX</p>
            <p className="Corporate-sub zoom_in">Case Study</p>
          </div>
          {/* Portfolio Item Six  */}
          <div>
            <div
              className="image-container popup-btn zoom_in"
              onClick={() =>
                window.open("https://www.behance.net/gallery/197936635/Shotej-Brand-Identity-Design", "_blank")
              }
              style={{ cursor: "pointer" }}
            >
              <img src={Galleryimg6} alt="Shotej Brand Identity Design" loading="lazy" />
              <div className="overlay">
                <img src={ContentSvg} alt="Portfolio icon" className="vimeo-icon" />
                <p className="overlay-text">Shotej Brand Identity Design</p>
              </div>
            </div>

            <p className="Corporate zoom_in">Shotej Brand Identity Design</p>
            <p className="Corporate-sub zoom_in">Brand Identity</p>
          </div>
        </div>

        <div className="wrapper view-all-btn zoom_in">
          <Link className="btn-hover" to="https://www.behance.net/annettefinney">
            View All
          </Link>
        </div>
      </section>
      <Popup isVisible={isPopupVisible} onClose={handlePopupClose} />
      {/* <!-- ====================================== Section Portfolio End ===================================== --> */}
      <div id="popup2" class="popup-container popup-style">
        <div class="popup-content popup-content-gallery">
          <a href="#pop" class="close">
            &times;
          </a>

          <main class="main">
            <h2 class="mobile_app">Gallery</h2>

            <div class="container">
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg1}
                    data-fancybox="gallery"
                    data-caption="Jewellery Social Media Post Design"
                  >
                    <img src={Galleryimg1} alt="Gallery Image: Jewellery Social Media Post Design" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg2}
                    data-fancybox="gallery"
                    data-caption="Organic Hair Oil Social Media Post"
                  >
                    <img src={Galleryimg2} alt="Gallery Image: Organic Hair Oil Social Media Post" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg3}
                    data-fancybox="gallery"
                    data-caption="Mens T-shirt Manipulation"
                  >
                    <img src={Galleryimg3} alt="Gallery Image: Mens T-shirt Manipulation" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg4}
                    data-fancybox="gallery"
                    data-caption="Agriculture Social Media Banner Design"
                  >
                    <img src={Galleryimg4} alt="Gallery Image: Agriculture Social Media Banner Design" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg5}
                    data-fancybox="gallery"
                    data-caption="Uniguide App UI/UX Case Study"
                  >
                    <img src={Galleryimg5} alt="Gallery Image: Uniguide App UI/UX Case Study" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg6}
                    data-fancybox="gallery"
                    data-caption="Shotej Brand Identity Design"
                  >
                    <img src={Galleryimg6} alt="Gallery Image: Shotej Brand Identity Design" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg7}
                    data-fancybox="gallery"
                    data-caption="Portfolio project image 7"
                  >
                    <img src={Galleryimg7} alt="Gallery Image: Portfolio project 7" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg8}
                    data-fancybox="gallery"
                    data-caption="Portfolio project image 8"
                  >
                    <img src={Galleryimg8} alt="Gallery Image: Portfolio project 8" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg3}
                    data-fancybox="gallery"
                    data-caption="Mens T-shirt Manipulation"
                  >
                    <img src={Galleryimg3} alt="Gallery Image: Mens T-shirt Manipulation" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg1}
                    data-fancybox="gallery"
                    data-caption="Jewellery Social Media Post Design"
                  >
                    <img src={Galleryimg1} alt="Gallery Image: Jewellery Social Media Post Design" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg2}
                    data-fancybox="gallery"
                    data-caption="Organic Hair Oil Social Media Post"
                  >
                    <img src={Galleryimg2} alt="Gallery Image: Organic Hair Oil Social Media Post" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg3}
                    data-fancybox="gallery"
                    data-caption="Mens T-shirt Manipulation"
                  >
                    <img src={Galleryimg3} alt="Gallery Image: Mens T-shirt Manipulation" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg4}
                    data-fancybox="gallery"
                    data-caption="Agriculture Social Media Banner Design"
                  >
                    <img src={Galleryimg4} alt="Gallery Image: Agriculture Social Media Banner Design" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg5}
                    data-fancybox="gallery"
                    data-caption="Uniguide App UI/UX Case Study"
                  >
                    <img src={Galleryimg5} alt="Gallery Image: Uniguide App UI/UX Case Study" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg1}
                    data-fancybox="gallery"
                    data-caption="Jewellery Social Media Post Design"
                  >
                    <img src={Galleryimg1} alt="Gallery Image: Jewellery Social Media Post Design" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg2}
                    data-fancybox="gallery"
                    data-caption="Organic Hair Oil Social Media Post"
                  >
                    <img src={Galleryimg2} alt="Gallery Image: Organic Hair Oil Social Media Post" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg3}
                    data-fancybox="gallery"
                    data-caption="Mens T-shirt Manipulation"
                  >
                    <img src={Galleryimg3} alt="Gallery Image: Mens T-shirt Manipulation" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg4}
                    data-fancybox="gallery"
                    data-caption="Agriculture Social Media Banner Design"
                  >
                    <img src={Galleryimg4} alt="Gallery Image: Agriculture Social Media Banner Design" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div class="card">
                <div class="card-image">
                  <Link
                    to={Galleryimg5}
                    data-fancybox="gallery"
                    data-caption="Uniguide App UI/UX Case Study"
                  >
                    <img src={Galleryimg5} alt="Gallery Image: Uniguide App UI/UX Case Study" loading="lazy" />
                  </Link>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};
export default Portfolio;
